export const LOCAL_STORAGE = {
  TOKEN: 'token',
};
